import { FC, useEffect } from 'react';
import { useField } from 'formik';
import { FieldGroup, IFormProps } from '.';
import UserInfoListViewModel from '../Models/UserInfoListViewModel';
import { ParticipantSelect } from 'src/Controls';
import { CustomerItemType } from 'src/Types';

interface IUserInfoListControlProps extends IFormProps {
	model: UserInfoListViewModel;
}

const UserInfoListControl: FC<IUserInfoListControlProps> = ({
	model,
	readOnly,
	setFieldValue,
}) => {
	const [inputProps, , helperProps] = useField(model.FullPath);
	const credentialHash =
		typeof inputProps.value === 'string'
			? inputProps.value
			: model.getCredentialHash();

	useEffect(() => {
		helperProps.setValue(model.Value, true);
		// eslint-disable-next-line
	}, [model.Value]);

	// Запоминаем имя вместе с хэшем, который передаётся в сценарии формы
	const onChangeValue = (user?: CustomerItemType) => {
		model.Value = user?.id;
		model.UserName = user?.text ?? '';
		setFieldValue(model.FullPath, user?.id);
	};

	// Дополняем автоподставленный хэш именем после ответа сервера
	const onResolveUser = (user: CustomerItemType) => {
		// Сервер может вернуть основной хэш вместо запрошенного хэша того же пользователя
		if (credentialHash === model.getCredentialHash()) {
			model.UserName = user.text;
		}
	};

	// Убираем сохранённое имя, если текущий хэш не удалось проверить
	const onLookupFailure = () => {
		model.UserName = '';
	};

	return (
		<FieldGroup
			hidden={!model.ControlVisibility}
			name={model.FullPath}
			title={model.Caption}
			width={model.Width ?? 12}
			readOnly={!model.ControlEnabling || readOnly}
			isInvalid={model.notValidClass}
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<ParticipantSelect
				{...inputProps}
				value={credentialHash}
				disabled={readOnly || !model.ControlEnabling}
				showClearBtn={!!credentialHash}
				paginationPageSize={20}
				setValue={onChangeValue}
				onResolve={onResolveUser}
				onLookupFailure={onLookupFailure}
				preserveValueOnLookupFailure
			/>
		</FieldGroup>
	);
};

export default UserInfoListControl;
